import { Routes } from '@angular/router';
import { configuracionRoutes } from './configuracion/configuracion.routes';
import { proveedoresRoutes } from './gestion-prov/gestion-prov.routes';
export const modulosLayoutRoutes: Routes = [...configuracionRoutes, ...proveedoresRoutes];
